import { useMutation } from 'react-query';

import { http, camelCaseToUnderscore, underscoreToCamelCase } from '../base/http';
import type { Export } from '../types';

export const useCreateExportMutation = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (e: Export) =>
            http.post<Export>('/exports', camelCaseToUnderscore(e)).then((d) => underscoreToCamelCase(d)),
        ...args,
    });
};
